<div class="d-flex flex-column h-100">
  <ng-content select="era-panel-header"></ng-content>
  <div class="flex-grow-1 overflow-y-auto">
    <div class="d-flex h-100">
      <ng-content select="era-panel-left"></ng-content>
      <div class="flex-grow-1 overflow-y-auto">
        <ng-content></ng-content>
      </div>
      <ng-content select="era-panel-right"></ng-content>
    </div>
  </div>
  <ng-content select="era-panel-footer"></ng-content>
</div>